export const translations = {
  en: {
    // Header
    siteName: "Ayushman Homoeo Cure",

    // Ailments
    ailmentsTreated: "AILMENTS TREATED",
    womenAilments: "WOMEN AILMENTS",
    respiratoryAilments: "RESPIRATORY AILMENTS",
    endometriosis: "ENDOMETRIOSIS",
    pcos: "POLYCYSTIC OVARIAN DISEASE",
    adenomyosis: "ADENOMYOSIS",
    fibroids: "FIBROIDS",
    allergy: "ALLERGY",
    asthma: "ASTHMA",
    bronchitis: "BRONCHITIS",

    // Testimonials
    successStories: "Success Stories",
    testimonial1Name: "Priya Krishnan",
    testimonial1Text: "I had been suffering from chronic migraine headaches for over 5 years. After just 3 months of homeopathic treatment at Ayushman, my headaches reduced significantly. Now I rarely get them and can finally enjoy life without constant pain. Truly grateful!",
    testimonial2Name: "Rajesh Kumar",
    testimonial2Text: "My son had recurring respiratory infections and was on antibiotics every month. Dr. Laxmi Prabha's holistic approach not only cured his infections but also strengthened his immunity. It's been 8 months now with no major illness. Thank you for giving him a healthy childhood!",

    // Consultation Form
    requestConsultation: "Request a Consultation",
    patientName: "Patient Name",
    contactNumber: "Contact Number",
    ailmentSummary: "Brief Description of Ailment",
    patientNamePlaceholder: "Enter your full name",
    contactNumberPlaceholder: "Enter your phone number",
    ailmentSummaryPlaceholder: "Briefly describe your health concern...",
    submitRequest: "Submit Request",
    formSubmitting: "Submitting...",
    formSuccess: "Thank you! Your consultation request has been submitted. We will contact you soon.",
    formError: "Sorry, there was an error. Please try again or contact us directly.",

    // Footer
    footerAddress: "Salem, Tamil Nadu, India",
    footerPhone: "Phone",
    footerEmail: "Email",
    sendSMS: "Send SMS",
    whatsappUs: "WhatsApp Us",

    // Language
    language: "Language",
    english: "English",
    tamil: "தமிழ்"
  },
  ta: {
    // Header
    siteName: "ஆயுஷ்மான் ஹோமியோ க்யூர்",

    // Ailments
    ailmentsTreated: "சிகிச்சையளிக்கப்படும் நோய்கள்",
    womenAilments: "பெண்களின் நோய்கள்",
    respiratoryAilments: "சுவாச நோய்கள்",
    endometriosis: "எண்டோமெட்ரியோசிஸ்",
    pcos: "பாலிசிஸ்டிக் ஓவேரியன் நோய்",
    adenomyosis: "அடினோமையோசிஸ்",
    fibroids: "ஃபைப்ராய்டுகள்",
    allergy: "ஒவ்வாமை",
    asthma: "ஆஸ்துமா",
    bronchitis: "மூச்சுக்குழாய் அழற்சி",

    // Testimonials
    successStories: "வெற்றிக் கதைகள்",
    testimonial1Name: "பிரியா கிருஷ்ணன்",
    testimonial1Text: "5 வருடங்களுக்கும் மேலாக நான் நாள்பட்ட ஒற்றைத் தலைவலியால் அவதிப்பட்டு வந்தேன். ஆயுஷ்மானில் வெறும் 3 மாதங்கள் ஹோமியோபதி சிகிச்சைக்குப் பிறகு, எனது தலைவலி கணிசமாகக் குறைந்தது. இப்போது அரிதாகவே வலி வருகிறது, நிலையான வலி இல்லாமல் இறுதியாக வாழ்க்கையை அனுபவிக்க முடிகிறது. மிகவும் நன்றி!",
    testimonial2Name: "ராஜேஷ் குமார்",
    testimonial2Text: "என் மகனுக்கு மீண்டும் மீண்டும் சுவாச தொற்றுகள் வந்து, ஒவ்வொரு மாதமும் நுண்ணுயிர் எதிர்ப்பிகளை எடுத்துக்கொண்டிருந்தார். டாக்டர் லட்சுமி பிரபாவின் முழுமையான அணுகுமுறை அவரது தொற்றுகளை குணப்படுத்தியது மட்டுமல்லாமல் அவரது நோய் எதிர்ப்பு சக்தியையும் வலுப்படுத்தியது. பெரிய நோய் இல்லாமல் இப்போது 8 மாதங்கள் ஆகிவிட்டன. அவருக்கு ஆரோக்கியமான குழந்தைப் பருவத்தை அளித்ததற்கு நன்றி!",

    // Consultation Form
    requestConsultation: "ஆலோசனை கோரிக்கை",
    patientName: "நோயாளியின் பெயர்",
    contactNumber: "தொடர்பு எண்",
    ailmentSummary: "நோயின் சுருக்கமான விவரம்",
    patientNamePlaceholder: "உங்கள் முழு பெயரை உள்ளிடவும்",
    contactNumberPlaceholder: "உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்",
    ailmentSummaryPlaceholder: "உங்கள் உடல்நலப் பிரச்சனையை சுருக்கமாக விவரிக்கவும்...",
    submitRequest: "கோரிக்கையை சமர்ப்பிக்கவும்",
    formSubmitting: "சமர்ப்பிக்கிறது...",
    formSuccess: "நன்றி! உங்கள் ஆலோசனை கோரிக்கை சமர்ப்பிக்கப்பட்டது. நாங்கள் விரைவில் உங்களைத் தொடர்புகொள்வோம்.",
    formError: "மன்னிக்கவும், பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும் அல்லது நேரடியாக எங்களைத் தொடர்பு கொள்ளவும்.",

    // Footer
    footerAddress: "சேலம், தமிழ்நாடு, இந்தியா",
    footerPhone: "தொலைபேசி",
    footerEmail: "மின்னஞ்சல்",
    sendSMS: "குறுஞ்செய்தி அனுப்பவும்",
    whatsappUs: "வாட்ஸ்அப் செய்யவும்",

    // Language
    language: "மொழி",
    english: "English",
    tamil: "தமிழ்"
  }
};
